import React, { useState } from 'react';

import {
  Button,
} from '@chakra-ui/react';

import { logout } from '../api';

// onSuccess opzionale
const Logout = () => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Button
      my={4}
      onClick={async () => {
        setIsLoading(true)
        await logout();
        setIsLoading(false)
      }}
      isLoading={isLoading}
    >
      Logout
    </Button>
  );
};

export default Logout;
